/* In-cart upsell add button.
   Bound once on document: the cart drawer replaces #CartDrawer.innerHTML on every
   cart update, and inline <script> tags injected that way never execute, so the
   handler must live outside the replaced subtree. */
(function () {
  if (window.__vtcCartUpsellsBound) return;
  window.__vtcCartUpsellsBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('.vtc-cart-upsells__btn');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble'
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (state) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });
})();
